import React, { ComponentProps } from "react";

export default function StopwatchIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8884 2.57146L10.4182 3.38509L12.0475 4.32549L12.5177 3.51184C12.6472 3.28599 12.5701 2.99943 12.3451 2.86894L11.5314 2.39873C11.3063 2.26838 11.0189 2.3455 10.8884 2.57146Z"
        fill="currentColor"
      />
      <path
        d="M7.99968 3.11739C8.29706 3.11739 8.58756 3.14648 8.87468 3.1875V2.42647L9.47624 2.42187V1.4375C9.47624 1.19568 9.28056 1 9.03874 1H6.96521C6.72339 1 6.52771 1.19568 6.52771 1.4375V2.42187L7.12468 2.42647V3.1875C7.41179 3.14648 7.70229 3.11739 7.99968 3.11739Z"
        fill="currentColor"
      />
      <path
        d="M8 3.625C4.85888 3.625 2.3125 6.17135 2.3125 9.3125C2.3125 12.4536 4.85888 15 8 15C11.1411 15 13.6875 12.4536 13.6875 9.3125C13.6875 6.17135 11.1411 3.625 8 3.625ZM10.6578 11.9856L7.34374 9.69128V6.45222H8.30013V9.19021L11.2022 11.1993L10.6578 11.9856Z"
        fill="currentColor"
      />
    </svg>
  );
}
